import { Component, OnInit, ViewChild, ElementRef, ChangeDetectionStrategy } from '@angular/core';
import { ErrorModel } from '../../Shared/Model/error/error-model';
import { AdminService } from '../../Shared/Services/Admin/admin.service';
import { ConfigLoaderService } from '../../Shared/Services/Config/config-loader.service';
import { ErrorServiceService } from '../../Shared/Services/Error/error-service.service';
import { AppType } from '../../Shared/Model/notification/notificationModal';
import { FileDetails, uploadDetails } from '../../Shared/Model/Docketupload/DocketUpload';
import { FormBuilder, UntypedFormGroup, Validators, UntypedFormControl, FormsModule, NgForm, ReactiveFormsModule } from '@angular/forms';
import { HttpEventType, HttpClient, HttpResponse } from '@angular/common/http';
// Not Supported anyomre
// import { MDBModalRef, MDBModalService } from 'angular-bootstrap-md';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Inject } from '@angular/core';
// import {
//   MatSnackBar,
//   MatSnackBarHorizontalPosition,
//   MatSnackBarVerticalPosition,
// } from '@angular/material/snack-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';

import { DocketUploadServiceService } from '../../Shared/Services/DocketUpload/docket-upload-service.service'
import { tap } from 'rxjs/operators';
import {appTypeValue} from '../../Shared/Model/enum';
declare var $: any;



@Component({
    selector: 'app-docket-upload',
    templateUrl: './docket-upload.component.html',
    styleUrls: ['./docket-upload.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DocketUploadComponent implements OnInit {

  errModal!: ErrorModel;
  appTypeList!: AppType[];

  enableFileUpload: boolean = true;
  uploadedFilesforCategory: FileDetails[] = [];
  showProgress = false;
  fileSelectedCount!: string;
  isFileTypeValid: boolean = false;
  selectedFiles!: FileList;
  validateFileUpload!: boolean;
  @ViewChild("fileInput", { static: false }) fileInput!: ElementRef;
  FileTypeValidationMsg: string = "";
  FileUploadValidationMsg: string = "";
  isnotValid: boolean = false;
  uploadedFiles: FileDetails[] = [];
  showonFileScan: boolean = false;
  showIfValidFiles: boolean = false;
  showProgressbar: boolean = false;
  loaded = 0;
  loading: boolean = false;
  fileList: any;
  // horizontalPosition: MatSnackBarHorizontalPosition = 'center';
  // verticalPosition: MatSnackBarVerticalPosition = 'top';
  default = "Select AppType";

  group = new UntypedFormGroup({
    AppType: new UntypedFormControl(null, Validators.required),
    fileupload: new UntypedFormControl(null, [Validators.required]),
    fileupload1: new UntypedFormControl(),
  });

  AppType:any;

  @ViewChild('f', { static: false }) myForm!: any;

  showSubmitButton: boolean = false;
  showalertMsg: boolean = false;
  alertMsg!: string;
  successMessage: string = "File Uploaded Successfully.";
  ErrorMessage: string = "Error in File Upload.";
  alertmsgClass!: string;

  // sFileName!:string;
  // sFileExtension! :string 
  //  iFileSize! :number 
  //  sFileExtensionLength!:number 


  constructor(
    // public modalRef: MDBModalRef,
    public _adminService: AdminService,
    private _errorService: ErrorServiceService,
    //  private _snackBar: MatSnackBar,
    private _docketUplaodService: DocketUploadServiceService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<DocketUploadComponent>
  ) {
    this.errModal = new ErrorModel();
  }

  ngOnInit(): void {
  
     this.getAppType();
   // this.ChangeFileCategory()
  }

  getAppType() {
    this.errModal.MethodName = "GETaPPtYPE";
    this.errModal.ErrorMessage = "Error getting getAppType";
    this._adminService
      .getAppTypeList(
        ConfigLoaderService.settings.AppSettings.userId
      )
      .subscribe(
        (data: any) => {
        
          if (data === undefined || data.length == 0) {
            this._errorService.handleError('', this.errModal)
          }
          else {
           
            //this.appTypeList = data.slice(1);
            this.appTypeList=data;
           
            // this.AppType = [
            //   'ECC',
            //   'BW',
            //   'HANA',
            //   'APO'
            // ];
          
          }
        },
        (error) => {
          this._errorService.handleError(error, this.errModal)

        }
      );

  }

  ChangeFileCategory() {

    this.enableFileUpload = false;
    this.uploadedFilesforCategory = [];
    this.showProgress = false;
    this.fileSelectedCount = " ";
  
    if (this.isFileTypeValid == true) {
      this.isFileTypeValid = false
    }
    
  }

  selectFile(event?: any): void {
   
    this.selectedFiles = event?.target.files;
    if (this.selectedFiles == null) {
      this.enableFileUpload = false;
    }
    else {
      this.enableFileUpload = true;
    }

    this.validateFileUpload = this.checkFileValidation();
 
    if (this.validateFileUpload) {
      this.fileSelectedCount = event?.target.files[0].name;
      
      // this.upload();
      this.showSubmitButton = true;
    }
    this.fileInput.nativeElement.value = '';

  }

  checkFileValidation() {
    let result: boolean = true;

    Array.from(this.selectedFiles).forEach((element: any) => {
      this.fileList = element
      var sFileName = element.name;
      var sFileExtension = sFileName.split('.')[sFileName.split('.').length - 1].toLowerCase();
      var iFileSize = element.size;
      var sFileExtensionLength = sFileName.split('.').length;



      if (this.group.get("AppType")?.value == null) {
        this.FileTypeValidationMsg = "Please select AppType ";
        result = false;
        this.isnotValid = true;
        this.enableFileUpload = false;
        this.isFileTypeValid = true;
      }
      else if (!(sFileExtension === "zip" || sFileExtension === "rar" || sFileExtension === "7zip") || iFileSize > ConfigLoaderService.settings.AppSettings.FileUploadLimit || element.size == 0 || (sFileExtensionLength > 2)) {
        //  if (!(iFileSize > ConfigService.settings.AppSettings.FileUploadLimit ) ){
        this.FileUploadValidationMsg = "Please check the Extension and size of the Files";
        result = false;
        this.isnotValid = true;
        this.enableFileUpload = false;
      }
      else if (sFileName.length > 255) {
        this.FileUploadValidationMsg = "Invalid FileName";
        result = false;
        this.isnotValid = true;
        this.enableFileUpload = false;
      }
      else {
        result = true;
      }

    });

    return result;
  }

  submit($event: any) {

    $event.preventDefault();
    this.showSubmitButton = false;
    this.errModal.UserId = ConfigLoaderService.settings.AppSettings.userId;
    this.errModal.ComponentName = "UploadComponent";
    this.errModal.MethodName = "Upload ";
    this.errModal.ErrorMessage = "Info";
    this._errorService.handleError('', this.errModal)
    if (this.uploadedFilesforCategory.length > 0) {
      this.showProgress = true;
    }
    this.uploadedFiles = [];
    let appType = this.group.get("AppType")?.value;
    if(appType=="S4HANA")
      appType=appTypeValue.S4HANA;
    //let fileName= this.sFileName;

    // Array.from(this.selectedFiles).forEach(file => {

    const fileDetails = new FileDetails();

    fileDetails.userId = ConfigLoaderService.settings.AppSettings.userId;
    fileDetails.name = this.fileList.name;
    let fileExtension: any = this.fileList.name.split('?')[0].split('.').pop();
    let FileName: any = this.fileList.name.split(".").shift();
    fileDetails.name = FileName + "." + fileExtension;

    this.uploadedFiles.push(fileDetails);
    this.uploadedFilesforCategory.push(fileDetails)
    this.fileSelectedCount = this.uploadedFilesforCategory.length + " Files are Selected";



    this._docketUplaodService.uploadSingleFile(this.fileList, ConfigLoaderService.settings.AppSettings.userId, appType)
      .pipe(tap((event: any) => {


        if (event.type === HttpEventType.UploadProgress) {
          this.showonFileScan = true;
          this.showIfValidFiles = false;
          this.showProgressbar = true;
          this.loaded = Math.round(100 * event.loaded / event.total);
          fileDetails.progress = this.loaded;
        }

      })).subscribe((event: any) => {
       
        if (event instanceof HttpResponse) {
          if (event["ok"] != undefined || event["ok"] != false) {
            
            this.showIfValidFiles = true;
            this.showonFileScan = false;
            this.showProgressbar = false;
            if (this.uploadedFilesforCategory.length != 0) {
             
              this.showProgress = true;
              this.loading = false;
            }
           
            this.alertmsgClass = 'alert alert-success';
            this.alertMsg = this.successMessage;
            this.showalertMsg = true;
            console.log( this.alertMsg)
            $("#success1").toast("show");
            this.group.reset();
            // this.resetFileUpload();
            this.ChangeFileCategory()
            this.fileSelectedCount = "";

          }
          else {  
            this.loading = true;
            this.showIfValidFiles = false;
            this.showonFileScan = true;
            // this.removeItinerary(file.name);
            this.enableFileUpload = false;
            if (this.uploadedFilesforCategory.length != 0) {
              this.showProgress = true;
              this.enableFileUpload = true;
            }

          }



        }
        else {
        
          this.loading = true;
          this.showonFileScan = true;
          this.showProgress = true;
        }



      }, (error: any) => {
       
        this.alertmsgClass = 'alert alert-danger';
        this.alertMsg = this.ErrorMessage;
        this.showalertMsg = false;

        $("#error").toast("show");
        this.showIfValidFiles = true;
        this.showonFileScan = false;
        //  this.openFailureSnackBar("Error in uploading Files : " + error.error);

        // this.removeItinerary(fileDetails.name);
        if (this.uploadedFilesforCategory.length != 0) {
          this.showProgress = true;
        }
        else {
          this.showProgress = false;
          this.enableFileUpload = false;
        }
        this.errModal.UserId = ConfigLoaderService.settings.AppSettings.userId;
        this.errModal.ComponentName = "uploadComponent";
        this.errModal.MethodName = "File Upload";
        this.errModal.ErrorMessage = error.error;
        // this.errModal.ErrorType="Error";
        // this.errModal.handleError(error, this.errorModel);
        //   this.logger.log("Error in Upload " + this.errorModel);
        this.loading = false;
        this.showProgressbar = false;
        this.showProgress = false;
        this.group.reset();
        // this.resetFileUpload();
        this.ChangeFileCategory()
        this.fileSelectedCount = "";
      }
      )
    // });
  }

  // removeSelectedFile(index:any, fName:any) {
  //   this.errModal.UserId = ConfigLoaderService.settings.AppSettings.userId;
  //   this.errModal.ComponentName = "uploadComponent";
  //   this.errModal.MethodName = "Delete File ";
  //   // this.errModal.ErrorType="Info";   
  //   // this.logger.log("File Remove Click ",this.errorModel ); 
  //   this.uploadService.removeuploadedFiles(fName, ConfigLoaderService.settings.AppSettings.userId).subscribe(
  //     (res:any) => {
  //       this.removeItinerary(fName)

  //       if (this.uploadedFilesforCategory.length == 0) {
  //         this.showProgress = false;
  //         this.fileSelectedCount = "";
  //         this.enableFileUpload = false;
  //       }
  //     },
  //     (error:any) => {

  //       this.openFailureSnackBar("Error in Deleting Files");
  //       this.errModal.UserId = ConfigLoaderService.settings.AppSettings.userId;       
  //       this.errModal.ComponentName = "uploadComponent";
  //       this.errModal.MethodName = "RemoveSelectedFile";
  //       this.errModal.ErrorMessage = error;
  //       // this.errModal.ErrorType="Error";
  //       // this._errorService.handleError(error, this.errorModel);
  //       // this.logger.log("Error in Upload " +this.errorModel); 

  //       //this.fileSelectedCount = "";
  //     }

  //   )
  //   // this.uploadedFilesforCategory.splice(index, 1);

  // }

  removeItinerary = (removeId: any) => {

    const index = this.uploadedFilesforCategory.findIndex(obj => obj.name === removeId)
    if (index > -1) {
      this.uploadedFilesforCategory.splice(index, 1);
    }
    this.fileSelectedCount = this.uploadedFilesforCategory.length + " Files are Selected";
    return index;
  }

  // openFailureSnackBar(message:string) {
  //   this._snackBar.open(message, "OK", {
  //     duration: 20000,
  //     panelClass: ['mat-toolbar', 'mat-warn'],
  //     horizontalPosition: this.horizontalPosition,
  //     verticalPosition: this.verticalPosition
  //   });
  // }

  // openInfoSnackBar(message: string) {
  //   this._snackBar.open(message, "", {
  //     duration: 2000,
  //     panelClass: ['mat-toolbar', 'mat-primary'],
  //     horizontalPosition: this.horizontalPosition,
  //     verticalPosition: this.verticalPosition
  //   });
  // }

  reset($event: any) {
    console.log('herheh');
    this.group.reset();
    // this.resetFileUpload();
    this.ChangeFileCategory()
    this.fileSelectedCount = "";

  }


}
